import GLOBAL from './GLOBAL'
import VN from './VN'
import PH from './PH'
import MY from './MY'
import TH from './TH'

const protocol: Record<string, string> = {
    GLOBAL,
    VN,
    PH,
    MY,
    TH,
}

export default protocol